import React from 'react';
import { Button } from '@mui/material';

// Exports the flows collected across pages and folders. The buttons keep their
// place and are only disabled, so the header does not jump.
const FlowBulkExportBar = ({ selectedFlows, clearSelection, onExport }) => (
    <>
        <Button onClick={onExport} variant="contained" disabled={!selectedFlows.length}>
            Export ({selectedFlows.length})
        </Button>
        <Button onClick={clearSelection} variant="outlined" disabled={!selectedFlows.length}>
            Clear
        </Button>
    </>
);

export default FlowBulkExportBar;
